const host = process.env.JIBJAB_API_HOST ? `https://${process.env.JIBJAB_API_HOST}` : "";

export default {
  rootPath: () => `${host}/v1`,
  invites: (slug) => (slug ? `${host}/v1/invites/${slug}` : `${host}/v1/invites`),
  inviteEvents: () => `${host}/v1/invite_events`,
  inviteGuests: (inviteSlug, guestSlug) =>
    guestSlug ? `${host}/v1/invites/${inviteSlug}/guests/${guestSlug}` : `${host}/v1/invites/${inviteSlug}/guests`,
};
